import Keycloak from "keycloak-js";
import keycloakConfig from "./KeycloakConfig";

export const keycloak = new Keycloak({
  realm: keycloakConfig.realmName,
  url: keycloakConfig.url,
  clientId: keycloakConfig.clientId,
});

export async function initKeycloak() {
  // `check-sso` keeps Keycloak from redirecting the current page automatically when a refresh
  // token becomes invalid. AuthenticationSession can then recover silently or in a popup while
  // preserving the mounted SPA and any in-memory form state.
  const auth = await keycloak.init({ onLoad: "check-sso", pkceMethod: "S256" });
  return { auth, keycloak };
}
